module.exports = __webpack_public_path__ + "static/media/10 Action 4.1d6bd930.JPG";